<div class="spen-ly-modal" id="modal" data-cy="modal-participants-list">
  <div class="modal-dialog">
    <div class="participants-inner">
      <div class="modal-heading">
        @if (layoutService.isTabletDownView.value) {
          <a (click)="onClose()"><i class="fa fa-times"></i></a>
        }
        <h2 class="heading-text">スペースの生徒・先生一覧</h2>
      </div>

      <div class="modal-content">
        @if (dataLoaded) {
          <div class="content-inner participants-modal-content">
            <span class="students-count">参加生徒：{{ studentPage().students_count | number }}名</span>
            <span>担当先生：{{ studentPage().teachers_count | number }}名</span>
            <div class="spen-mod-segmentation">
              <a class="segment-column" [ngClass]="!teacherTab ? 'is-primary' : 'is-default'" (click)="changeTab('student')"> 参加生徒 </a>
              <a class="is-default segment-column" [ngClass]="teacherTab ? 'is-primary' : 'is-default'" (click)="changeTab('teacher')">
                担当先生
              </a>
            </div>
            <div class="users-list">
              @if (!teacherTab) {
                <ul>
                  @for (student of students; track student.id) {
                    <li [ngClass]="student.viewer_permission ? 'clickable-item' : 'disabled-item'">
                      <div class="user">
                        <div>
                          <img [src]="student.avatar" />
                        </div>
                        <div class="user-info truncate-text">
                          <a class="spen-util-link" [routerLink]="['/students/teacher/', student.id]">{{ student.name }}</a>
                          @if (student.class_name) {
                            <p class="truncate-text">{{ student.class_name }}{{ student.attendance_number }}番</p>
                          }
                        </div>
                      </div>
                    </li>
                  }
                </ul>
              }
              @if (teacherTab) {
                <ul>
                  @for (teacher of teachers; track teacher.id) {
                    <li>
                      <div class="user">
                        <img [src]="teacher.avatar" />
                        <span class="truncate-text">{{ teacher.name }}</span>
                        @if (teacher.id === teacherPage().create_user_id) {
                          <span class="self">（作成者）</span>
                        }
                      </div>
                    </li>
                  }
                </ul>
              }
            </div>
            @if (showStudentPagination || showTeacherPagination) {
              <div class="pagination">
                <spen-paginator
                  [length]="currentPagination().total_pages"
                  [pageIndex]="currentPagination().current_page - 1"
                  (page)="pageChanged($event)"
                />
              </div>
            }
            @if (!teacherTab) {
              <div class="permission-message">
                <div class="muted-text">
                  選択できない項目は、[設定・登録]の[閲覧権限]ならびに[先生情報]の設定により、閲覧が制限されています。
                </div>
                <div class="muted-text">※閲覧権限の変更は、校内のClassi管理責任者 / 管理者の先生にご相談ください。</div>
              </div>
            }
          </div>
        } @else {
          <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
        }
      </div>

      @if (!layoutService.isTabletDownView.value) {
        <div class="modal-footer participants-modal-footer">
          <div class="modal-actions is-right-actions">
            <a class="spen-mod-btn is-default js-close-modal-trigger" (click)="onClose()">閉じる</a>
          </div>
        </div>
      }
    </div>
  </div>
</div>
